import { axios } from '@/utils/request';
import notification from 'ant-design-vue/es/notification';
import { uuid } from './util';

/**
 * 带进度条的download
 * @param url
 * @param options
 */
export default function download(url, options = {}) {
  const notificationKey = uuid();
  const op = {
    props: options,
  };
  downloadFile(url, {
    onDownloadProgress(evt) {
      let duration = null;
      const percent = ((evt.loaded / evt.total) * 100).toFixed(2) - 0;
      if (percent >= 100) {
        duration = 1;
      }
      notification.open({
        key: notificationKey,
        message: '文件下载中...',
        duration,
        description() {
          return (
            <a-progress percent={percent} {...op} />
          );
        },
      });
    },
  });
}

/**
 * @eg:
 * download('/modal', {
 *   onDownloadProgress () {
 *
 *   },
 *   onSuccess () {
 *
 *   }
 * })
 * @param url
 * @param options
 * @returns {Promise<AxiosResponse<any>>}
 */
export function downloadFile(url, options = {}) {
  return axios({
    url,
    method: 'get',
    responseType: 'blob',
    timeout: 0,
    onDownloadProgress(evt) {
      if (evt.loaded >= evt.total) {
        options.onSuccess && options.onSuccess();
      }
      options.onDownloadProgress && options.onDownloadProgress(evt);
    },
  }).then((data) => {
    const link = document.createElement('a');
    const url = window.URL.createObjectURL(new Blob([data]));

    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', data.fileName || 'excel.xlsx');

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  })
    .catch((err) => {
      options.onError && options.onError(err);
    });
}

/**
 * 下载二进制流文件
 * @param res
 */
export function downloadBlobFile(res) {
  const blob = new Blob([`\uFEFF + ${res.data}`]);
  // const blob = res.data
  let fileName = res.headers['content-disposition'].split(';')[1].split('=')[1];
  fileName = decodeURI(fileName);
  if ('download' in document.createElement('a')) { // 非IE下载
    const elink = document.createElement('a');
    elink.download = fileName;
    elink.style.display = 'none';
    elink.href = window.URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href);
    document.body.removeChild(elink);
  } else { // IE10+下载
    navigator.msSaveBlob(blob, fileName);
  }
}
